export default __webpack_public_path__ + "7515e5e6bd74a7a2d684849e934b5cda.svg";